import { Link, useLocation } from "react-router-dom";
import { Film, History, Home, Radio, Tv } from "lucide-react";

// Five destinations, maximum. Per the 2026 phone design the tab bar carries
// section entries only — Search moved to the header, and Favorites, Settings
// and the app download live in the drawer. Seven tabs at 390px gave every
// target ~48px of width, below the 44pt minimum once padding is counted.
const items = [
  { to: "/hub", icon: Home, label: "Home" },
  { to: "/livetv", icon: Radio, label: "Live" },
  { to: "/movies", icon: Film, label: "Films" },
  { to: "/series", icon: Tv, label: "Series" },
  { to: "/catchup", icon: History, label: "Catch up" },
];

export function MobileNav() {
  const loc = useLocation();
  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-canvas/95 backdrop-blur-xl border-t border-line px-2 pb-[env(safe-area-inset-bottom)]">
      <div className="flex items-center justify-around">
        {items.map((it) => {
          const Icon = it.icon;
          const active = loc.pathname === it.to || loc.pathname.startsWith(it.to + "/");
          return (
            <Link
              key={it.to}
              to={it.to}
              aria-current={active ? "page" : undefined}
              className={`flex-1 flex flex-col items-center justify-center gap-1 min-h-[52px] py-2 rounded-ctrl transition-colors duration-press ease-bz ${
                active ? "text-accent-gold" : "text-text-secondary"
              }`}
            >
              <Icon size={20} />
              <span className="text-[10px] font-ui font-medium uppercase tracking-[0.04em]">
                {it.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
